
export default class StringUtils {

    static getPriceString= function(value) {
        return value ? value.toLocaleString("en-US") : value;
    }
}

